"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTHORIZE_ENTITY_NAME_TYPE = void 0;
const TRANSACTION = 'transaction';
const CUSTOMER_PROFILE = 'customerProfile';
const CUSTOMER_PAYMENT_PROFILE = 'customerPaymentProfile';
const SUBSCRIPTION = 'subscription';
exports.AUTHORIZE_ENTITY_NAME_TYPE = {
    TRANSACTION,
    CUSTOMER_PROFILE,
    CUSTOMER_PAYMENT_PROFILE,
    SUBSCRIPTION
};
//# sourceMappingURL=authorizeEntityNameType.js.map